import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'shortenUrl',
})
export class ShortenUrlPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) {
      return '';
    }

    // Strip protocol
    let stripped = value.replace(/^https?:\/\//, '');

    if (stripped.length <= 40) {
      return stripped;
    }

    return stripped.substring(0, 37) + '...';
  }
}
